import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { IConfirmation } from '@/components/11_Confirmation/types';

/**
 * @todo Api 回傳值
 */
export interface ConfirmationViewDataResp extends GeneralResp {
    result: {
        data: IConfirmation;
    };
}

/**
 * @todo 資料確認 ViewData
 */
const ConfirmationViewData = (): Promise<ConfirmationViewDataResp> => {
    const url = RouteUrlList.API_ConfirmationViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<ConfirmationViewDataResp>) => {
        return res.data;
    });
};

export default ConfirmationViewData;
